import { Button } from '../../../../../common/components/button/Button'
import { Input } from '../../../../../common/components/input/Input'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { PriceDocumentInterface } from '../../../../../common/types/interfaces'
import plus from '../../../../../assets/images/icons/add.svg'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { Item } from './Item'

type Props = {
  edit: boolean
  document: Partial<PriceDocumentInterface>
  setDocument: React.Dispatch<React.SetStateAction<Partial<PriceDocumentInterface>>>
  getList: () => void
  setModalActive: React.Dispatch<React.SetStateAction<boolean>>
  addPrice: () => void
  removePrice: (index: number) => void
}

export const Form = ({
  edit,
  document,
  setDocument,
  getList,
  setModalActive,
  addPrice,
  removePrice,
}: Props) => {
  const {
    formAction,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    createSaleItemSelectList,
    handlePriceChange,
    getItemValidationResult,
    markFieldDirty,
  } = useForm(document, setDocument, edit, getList, setModalActive)

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        {edit ? 'Редактирование документа' : 'Новый документ цен'}
      </div>

      <Input
        type={'text'}
        fieldName={'number'}
        value={document.number || ''}
        placeHolder={'Номер документа'}
        onChangeHandler={inputHandler}
        itemValidationResult={getValidationResult('number')}
        onBlur={setDirty}
      />

      <Input
        type={'text'}
        fieldName={'comment'}
        value={document.comment || ''}
        placeHolder={'Комментарий (необязательно)'}
        onChangeHandler={inputHandler}
        itemValidationResult={getValidationResult('comment')}
        onBlur={setDirty}
      />

      <div className={classes.title}>ТОВАРЫ</div>
      <IconButton display onClick={addPrice} icon={plus} alt="Добавить" small />

      <div className={classes.items}>
        {document.prices?.map((price, index) => (
          <Item
            key={index}
            idx={index}
            item={price}
            onRemove={removePrice}
            onChange={handlePriceChange}
            onBlur={markFieldDirty}
            saleItemOptions={createSaleItemSelectList()}
            getItemValidationResult={getItemValidationResult}
          />
        ))}
      </div>

      <Button text={edit ? 'Сохранить' : 'Создать'} onClick={formAction} disabled={disabled} />
    </div>
  )
}
